import plaqueClueBackgroundImg from './plaque_clue_background.png';
import agilityClueTextImg from './texts/agility_clue_text.svg';
import collectibleClueTextImg from './texts/collectible_clue_text.svg';
import speedClueTextImg from './texts/speed_clue_text.svg';
import './CluePopup.css';

export type ClueId = 'speed' | 'collectible' | 'agility';

const CLUE_CONFIG = {
  speed: {
    top: 264.5879,
    text: {
      src: speedClueTextImg,
      top: 295.002,
      width: 256,
      height: 111,
    },
  },
  collectible: {
    top: 457.418,
    text: {
      src: collectibleClueTextImg,
      top: 487.832,
      width: 177,
      height: 111,
    },
  },
  agility: {
    top: 650.248,
    text: {
      src: agilityClueTextImg,
      top: 680.6621,
      width: 338,
      height: 105,
    },
  },
} as const;

const PLAQUE_WIDTH = 368;

type CluePopupProps = {
  clueId: ClueId;
};

/** Stat clue popup (Figma clue_booster / clue_marshmallow / clue_let). */
export function CluePopup({ clueId }: CluePopupProps) {
  const clue = CLUE_CONFIG[clueId];
  const textLeft = 437 + (PLAQUE_WIDTH - clue.text.width) / 2;

  return (
    <div
      className="clue-popup"
      style={{ top: clue.top }}
      role="tooltip"
      aria-hidden={false}
    >
      <img
        className="clue-popup__background"
        src={plaqueClueBackgroundImg}
        alt=""
        draggable={false}
      />
      <img
        className="clue-popup__text"
        src={clue.text.src}
        alt=""
        draggable={false}
        style={{
          top: clue.text.top - clue.top,
          left: textLeft - 437,
          width: clue.text.width,
          height: clue.text.height,
        }}
      />
    </div>
  );
}
